import { composeBundles, createCacheBundle, createUrlBundle } from 'redux-bundler';
import cache from '../cache';
import createJwtApiBundle from './create-jwt-api-bundle';
import fileStorageBundle from './file-storage-bundle';
import JDFormDataBundle from './jdform-data-bundle';
import PermitsDataBundle from './permits-data-bundle';
import preAppFormDataBundle from './preappform-data-bundle';
import requestDataBundle from './request-data-bundle';
import violationsFormDataBundle from './violationsform-data-bundle';
import nprFormDataBundle from './npr-data-bundle';

export default composeBundles(
  /** -- START APPLICATION BUNDLES -- **/
  createCacheBundle(cache.set),
  createJwtApiBundle({
    root: import.meta.env.VITE_API_URL,
  }),
  createUrlBundle(),
  PermitsDataBundle,
  /** -- END APPLICATION BUNDLES -- **/

  /** -- START API BUNDLES -- **/
  fileStorageBundle,
  JDFormDataBundle,
  preAppFormDataBundle,
  requestDataBundle,
  violationsFormDataBundle,
  nprFormDataBundle
  /** -- END API BUNDLES -- **/
);
